<template>
  <div class="plantManage column-me">
    <div class="card-div column-me flex1">
      <div class="row-me row-center flex-wrap">
        <div class="width400">
          <el-input placeholder="请输入厂商名称" style="width: 100%;" clearable v-model="name"></el-input>
        </div>
        <div class="row-me row-center margin-left20">
          <el-checkbox v-model="checked1">
            供应商
          </el-checkbox>
          <el-checkbox v-model="checked2" class="margin-left30">
            生产商
          </el-checkbox>
        </div>
        <div class="row-me row-center margin-left40">
          <div class="btn-blue width100 btn-height40" @click="clickSearh">
            <el-icon>
              <search/>
            </el-icon>
            查询
          </div>
          <div class="btn-blank width100 btn-height40 margin-left20" @click="clickClear">清空</div>
        </div>
        <div class="flex1"></div>
        <div class="btn-blue width140 btn-height40" @click="clickAdd" v-if="canOperate">
          <el-icon>
            <plus/>
          </el-icon>
          新增
        </div>
      </div>
      <div class="column-me flex1 margin-top20">
        <div class="flex1">
          <el-table :data="tableData" border header-cell-class-name="table-header-style"
                    cell-class-name="table-cell-font">
            <el-table-column prop="name" label="厂商名称" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="supplier" label="是供应商" align="center" show-overflow-tooltip>
              <template #default='scope'>
                {{ scope.row.supplier ? '是' : '否' }}
              </template>
            </el-table-column>
            <el-table-column prop="producer" label="是生产商" align="center" show-overflow-tooltip>
              <template #default='scope'>
                {{ scope.row.producer ? '是' : '否' }}
              </template>
            </el-table-column>
            <el-table-column prop="contacts" label="联系人" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="phone" label="联系方式" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="address" label="厂商地址" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="remark" label="描述" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作列" align="center" width="250" v-if="canOperate">
              <template v-slot="scope">
                <div class="row-me center-all">
                  <div class="btn-blue width100 btn-height40" @click="clickEdit(scope.row)">
                    <el-icon>
                      <edit/>
                    </el-icon>
                    修改
                  </div>
                  <div class="btn-grey width100 btn-height40 margin-left20"
                       @click="clickDelete(scope.row)">
                    <el-icon>
                      <delete/>
                    </el-icon>
                    删除
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="margin-top20">
          <el-pagination background @current-change="handleCurrentChange" :current-page.sync="pageNo"
                         layout="total, prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>


    <!-- 新增 -->
    <el-dialog title="新增" v-model="visible" width="45%" top="10vh" :destroy-on-close="true">
      <div class="dialog-content">
        <div class="row-me row-center">
          <div class="title1"><span class="red-star">*</span>厂商名称：</div>
          <div class="width250">
            <el-input placeholder="请输入厂商名称" style="width: 100%;" clearable v-model="selectItem.name"
                      :class="{'red-border':showRedBorder&&selectItem.name===''}" maxlength="50">
            </el-input>
          </div>
          <div class="row-me row-center margin-left80">
            <el-checkbox v-model="selectItem.supplier">
              是供应商
            </el-checkbox>
            <el-checkbox v-model="selectItem.producer" class="margin-left30">
              是生产商
            </el-checkbox>
          </div>
        </div>
        <div class="row-me row-center flex-sb margin-top30">
          <div class="row-me row-center">
            <div class="title1">联系人名称：</div>
            <div class="width250">
              <el-input placeholder="请输入联系人名称" style="width: 100%;" clearable
                        v-model="selectItem.contacts">
              </el-input>
            </div>
          </div>
          <div class="row-me row-center">
            <div class="title1">联系方式：</div>
            <div class="width250">
              <el-input placeholder="请输入联系方式" style="width: 100%;" clearable v-model="selectItem.phone">
              </el-input>
            </div>
          </div>
        </div>
        <div class="row-me row-center flex-sb margin-top30">
          <div class="row-me row-center">
            <div class="title1">账单联系人名称：</div>
            <div class="width250">
              <el-input placeholder="请输入账单联系人名称" style="width: 100%;" clearable
                        v-model="selectItem.billContacts">
              </el-input>
            </div>
          </div>
          <div class="row-me row-center">
            <div class="title1">账单地址：</div>
            <div class="width250">
              <el-input placeholder="请输入账单地址" style="width: 100%;" clearable
                        v-model="selectItem.billAddress">
              </el-input>
            </div>
          </div>
        </div>
        <div class="row-me row-center margin-top30">
          <div class="row-me row-center width100Per">
            <div class="title1">厂商地址：</div>
            <div class="flex1">
              <el-input placeholder="请输入厂商地址" style="width: 100%;" clearable v-model="selectItem.address">
              </el-input>
            </div>
          </div>
        </div>
        <div class="row-me row-center margin-top30">
          <div class="row-me width100Per">
            <div class="title1">描述：</div>
            <div class="flex1">
              <el-input placeholder="请输入描述" type="textarea" style="width: 100%;" clearable
                        v-model="selectItem.remark" maxlength="500">
              </el-input>
            </div>
          </div>
        </div>
        <div class="row-me row-center flex-end1 margin-top80">
          <div class="btn-blue width140 btn-height40" @click="clickSave">保存</div>
          <div class="btn-grey width140 btn-height40 margin-left20" @click="clickCancel">取消</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      name: '',
      checked1: true,
      checked2: true,
      tableData: [],
      pageNo: 1,
      total: 0,
      visible: false,
      selectItem: {
        name: '',
        supplier: false,
        producer: false,
        contacts: '',
        phone: '',
        billContacts: '',
        billAddress: '',
        address: '',
        remark: '',
      },
      showRedBorder: false,
      canOperate: false,
    }
  },
  // html加载完成之前
  created() {
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.pageNo = 1
    this.getData()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    //查询
    clickSearh() {
      this.pageNo = 1
      this.getData()
    },
    //清空
    clickClear() {
      this.name = ''
      this.checked1 = true
      this.checked2 = true
      this.pageNo = 1
      this.getData()
    },
    //新增
    clickAdd() {
      this.selectItem = {
        name: '',
        supplier: false,
        producer: false,
        contacts: '',
        phone: '',
        billContacts: '',
        billAddress: '',
        address: '',
        remark: '',
      }
      this.visible = true
    },
    //编辑
    clickEdit(item) {
      this.selectItem = this.$method.deepClone(item)
      this.visible = true
    },
    //删除
    clickDelete(item) {
      this.$confirm("您确定要删除【" + item.name + "】吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postRequest('/admin/supplier/delete', [item.id]).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.pageNo = 1
            this.getData()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //保存
    clickSave() {
      if (this.selectItem.name === '') {
        this.showRedBorder = true
        this.$message.error('请输入厂商名称')
        return
      }
      if (this.selectItem.supplier === false && this.selectItem.producer === false) {
        this.$message.error('是供应商和是生产商必须选择一个')
        return
      }
      this.$postRequest('/admin/supplier/update', this.selectItem).then((res) => {
        if (res) {
          this.visible = false
          this.$message.success(res.message)
          this.pageNo = 1
          this.getData()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //取消
    clickCancel() {
      this.visible = false
    },
    //页数改变
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
      this.getData()
    },
    //获取数据
    getData() {
      let param = {
        name: this.name,
        pageNumber: this.pageNo,
      }
      if (this.checked1) {
        param.supplier = this.checked1
      }
      if (this.checked2) {
        param.producer = this.checked2
      }
      this.$getRequest('/admin/supplier/page', param).then((res) => {
        if (res) {
          this.total = res.data.totalRow
          this.tableData = res.data.list
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.plantManage {
  height: 100%;

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    overflow: auto;
  }

  .dialog-content {
    padding-bottom: 10px;

    .title1 {
      width: 150px;
      text-align: right;
    }
  }
}
</style>
